/**
 * Shared types for the Aircall frontend integration.
 *
 * Mirrors the backend enum values (insure/services/aircall + SalesLeadActivity)
 * verbatim so the wire format doesn't need adapters.
 */

export enum NumberLabel {
  Phone = 'Phone',
  Cell = 'Cell',
}

export type AircallStatus = 'loading' | 'ready' | 'error' | 'disabled'

export interface AircallIdentity {
  aircallUserId: number
  aircallEmail: string
}

export interface AircallNumber {
  // A NumberLabel (Phone/Cell) or, when listing numbers across multiple
  // contacts, the contact's name so the dropdown shows who you're reaching.
  label: string
  value: string // E.164
  // When the number belongs to a specific contact (e.g. a carrier contact),
  // the resulting call/SMS is attributed to it. Falls back to the caller's
  // contactId prop when absent.
  contactId?: string
}

export interface RingingCall {
  direction: 'inbound' | 'outbound'
  from: string
  to: string
}
